const callbacks = [];
let glueAsReady = undefined;
export function onGlueReady(callback) {
    if (glueAsReady) {
        callback(glueAsReady);
        return;
    }
    callbacks.push(callback);
    return () => {
        const number = callbacks.indexOf(callback);
        if (number > -1) {
            callbacks.splice(number, 1);
        }
    };
}
export function triggerGlueReady(glue) {
    glueAsReady = glue;
    callbacks.forEach(cb => {
        cb(glue);
    });
}
//# sourceMappingURL=glue-on-ready.js.map